import styles from './About.module.css'
import discoGiratorio from './disco.png'

export default function About(){
    return(
        <div className={styles.container} id='about'>
            <div className={styles.aboutSection}>
                <div className={styles.discoGiratorioSection}  data-aos="fade-left">
                    <img src={discoGiratorio} alt='imagem giratoria devzone' className={styles.disco}></img>
                </div>
                <div className={styles.textoSection}>
                    <h2 className={styles.titulo}>Sobre a <span className={styles.tituloMarcado}>DevZone</span></h2>
                    <p className={styles.texto}>
                        A DevZone Innovations é uma empresa de tecnologia especializada no desenvolvimento 
                        de soluções digitais personalizadas para negócios de diferentes segmentos e portes. 
                        Com experiência em projetos de tecnologia e atuação em contextos nacionais e 
                        internacionais, a empresa combina inovação, engenharia de software e visão 
                        estratégica para transformar necessidades de negócio em experiências digitais 
                        eficientes, modernas e escaláveis.
                    </p>
                    <p className={styles.texto}>
                        Nosso trabalho vai além do desenvolvimento de sites: buscamos compreender os 
                        objetivos de cada cliente para criar soluções sob medida, alinhadas à identidade 
                        da marca, às necessidades do público e às estratégias de crescimento do negócio. 
                        A DevZone Innovations atua com foco em qualidade, inovação, desempenho e excelência, 
                        estabelecendo parcerias de longo prazo e entregando tecnologia que gera valor real 
                        para nossos clientes.
                    </p>
                </div>
            </div>
            <div className={styles.botaoOrçamento}  data-aos="fade-down">
                <a href='https://wa.me/5511985050470' target="_blank" rel="noopener noreferrer">Fale conosco</a>
            </div>
        </div>
    )
}